import {axios} from "~/plugins/axios";

const getDefaultState_ProjectService = () => {
  return {
    call: null,
    result: [],
    // project: {
    //   project_days: {
    //     coments: null
    //   }
    // }
  }
}
const state = getDefaultState_ProjectService();

const getters = {
  call: state => state.call,
  getResult: state => state.result,
}

const actions = {
  async loadTranscribeSearch({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true})
    try {
      let resp = await axios.post('/api/reports/speech-analysis/transcribe-search', payload)
      commit('shared/SET_LOADING', false, {root: true})
      this.dispatch('shared/setMeta', resp.data.meta)
      return resp.data.data

    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})
      commit('shared/SET_LOADING', false, {root: true})

      throw err
    }
  },

  async loadCalls({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true})
    try {
      //let resp = await axios.post('/api/reports/speech-analysis/calls', payload)
      let resp = await axios.get('/api/reports/speech-analysis/calls', {params:payload})
      commit('shared/SET_LOADING', false, {root: true})

      //commit('SET_DICTIONARIES', resp.data.data)

      this.dispatch('shared/setMeta', resp.data.meta)
      return resp.data.data

    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})
      commit('shared/SET_LOADING', false, {root: true})

      throw err
    }
  },

  async loadWiretappingRate({commit}, payload) {
    return await axios.post('/api/reports/project-service', payload)
      .then(response => {
        this.dispatch('shared/setMeta', response.data.meta)

        return response.data.data;

      }).catch(err => {
        commit('shared/SET_ERROR', err.response.data, {root: true});

        throw err;
      });
  },

  async loadAgentsInQueues({commit}, payload) {
    return await axios.post('/api/reports/count-agent-in-queues', payload)
      .then(response => {
        return response.data
      }).catch(err => {
        commit('shared/SET_ERROR', err.response.data, {root: true})

        throw err
      })
  },

  /**
   * @param commit
   * @param {string} uid
   * @param {Object} query
   */
  async loadCall({commit}, {uid, query}) {
    commit('shared/SET_LOADING', true, {root: true});
    await axios.get('/api/reports/calls/' + uid, {params: query})
      .then(response => {
        commit('SET_CALL', response.data.data);
        this.dispatch('transcribe/changePhrases', response.data.data['transcribe']);
      }).catch(error => {
        commit('shared/SET_ERROR', error.response.data, {root: true});
        // commit('shared/SET_ERROR', error.response, {root: true});

        throw error;
      });

    commit('shared/SET_LOADING', false, {root: true});
  },

  clearCall({commit}) {
    commit('SET_CALL', null);
  },

  setResult({commit}, payload) {
    commit('ADD_RESULT', payload)
  },

  clearResult({commit}) {
    commit('CLEAR_RESULT')
  },

  addComment({commit}, data) {
    commit;
    return axios.post("/api/reports/project-service/comment", data)
      .then((response) => {
        return response;
      })
      .catch(error => {
        throw error;
      })
  },

  removeComment({commit}, data) {
    console.log(data);
    commit;
    return axios.delete("/api/reports/project-service/comment/"+data.id)
      .then((response) => {
        return response;
      })
      .catch(error => {
        throw error;
      })
  },

  setDayFlag({ commit }, data) {
    return axios.post('/api/reports/project-service/day-flag', data)
      .then((response) => response)
      .catch((error) => {
        if (error.response && error.response.data) {
          commit('shared/SET_ERROR', error.response.data, { root: true })
        }
        throw error
      })
  },
}

const mutations = {
  SET_CALL(state, data) {
    state.call = data;
  },

  ADD_RESULT(state, data ) {
    state.result.push(data)
  },

  CLEAR_RESULT(state) {
    state.result = []
  },

  // ADD_COMMENT(state, data) {
  //   state.project.project_days[1].comments.push(data)
  // },


  RESET_STATE_PROJECTSERVICE (state) {
    Object.assign(state, getDefaultState_ProjectService())
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
